<template>
  <v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false">
    <template v-slot:activator="{ attrs: menuAttrs, on: menuListeners }">
      <v-text-field
        v-model="formattedPlannedDate"
        label="Data do Procedimento"
        dense
        outlined
        clearable
        readonly
        :hide-details="!errorMessages"
        :error-messages="errorMessages"
        v-bind="menuAttrs"
        v-on="menuListeners"
      />
    </template>

    <v-select
      v-model="facilitator"
      outlined
      dense
      label="Facilitadores"
      :items="futureServiceDateHelpers"
      item-text="text"
      item-value="date"
      hide-details
      background-color="white"
      placeholder="Selecione..."
      class="mt-12"
      @input="applyFacilitator($event)"
    />

    <v-btn text color="primary" @click="closeDateMenu">Cancelar</v-btn>

    <v-btn text color="primary" @click="$refs.dateMenu.save(plannedDate)">
      OK
    </v-btn>
  </v-menu>
</template>

<script>
import { futureServiceDateHelpers } from "@/components/medical_request/medical_request_item/future_service_date_helpers.js";

export default {
  name: "MedicalRequestItemPlannedDateForm",
  props: {
    plannedDate: String,
    errorMessages: [Array, String],
  },
  data() {
    return {
      dateMenu: false,
      facilitator: null,
      futureServiceDateHelpers: futureServiceDateHelpers(),
    };
  },
  computed: {
    formattedPlannedDate: {
      get() {
        {
          if (!this.plannedDate) return "";
          
          return this.$moment(this.plannedDate).format("MM/YYYY");
        }
      },
      set() {
        this.updatePlannedDate(null);
      },
    },
  },
  methods: {
    closeDateMenu() {
      this.dateMenu = false;

      this.updatePlannedDate(null);
    },
    updatePlannedDate(value) {
      this.$emit("update:plannedDate", value);
    },
    applyFacilitator(value) {
      this.updatePlannedDate(value);

      this.$nextTick(() => {
        this.facilitator = null;
      });
    },
  },
};
</script>

<style></style>
